import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const CTAButton = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap justify-center gap-4 py-10 px-4">
      {/* Main CTA Button */}
      <Link
        to="/contact"
        aria-label={t("cta.aria")}
        className="relative px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-semibold text-white
                   rounded-2xl bg-gradient-to-r from-blue-500 to-blue-700
                   hover:scale-105 hover:shadow-[0_0_25px_rgba(59,130,246,0.6)]
                   transform transition-transform duration-300 ease-out
                   shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        {t("cta.button")}
      </Link>

      {/* Facebook Button */}
      <a
        href="https://www.facebook.com/RawangiTravelandTours"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit Rawangi Travel and Tours Facebook page"
        className="inline-flex items-center gap-2 px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-semibold text-white
                   rounded-2xl bg-gradient-to-r from-blue-600 to-blue-800
                   hover:scale-105 hover:shadow-[0_0_25px_rgba(59,130,246,0.6)]
                   transform transition-transform duration-300 ease-out
                   shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        <FaFacebook size={22} />
        {t("cta.facebook")}
      </a>
    </div>
  );
};

export default CTAButton;
